import errorLogger from './error-logger'
import store from '@/store'

// Vue error handler to catch errors Vue encounters
const errorHandler = (err, vm, info) => {
  console.log('error-handling errorHandler')
  console.log(`err:${err} | vm:${vm} | info:${info}`)

  store.commit('errors/show', err)
  errorLogger.logError(`err:${err} | vm:${vm} | info:${info}`)
}

// general (non vue related) javascript errors global error handler
window.onerror = (msg, url, line, col, error) => {
  console.log('error-handling onerror')
  console.log(`msg:${msg} | url:${url} | line:${line} | col:${col} | error:${error}`)

  store.commit('errors/show', msg)
  errorLogger.logError(`msg:${msg} | url:${url} | line:${line} | col:${col} | error:${error}`)
}

// to catch a "Promise rejection"
window.addEventListener('unhandledrejection', event => {
  console.log('error-handling unhandledrejection')
  console.log(`event.promise:${event.promise} | event.reason:${event.reason}`)

  store.commit('errors/show', event.reason)
  errorLogger.logError(`event.promise:${event.promise} | event.reason:${event.reason}`)
})

export default errorHandler
